import getTitle from 'helpers/getTitle'
import {getId} from 'apis/model/base'
import _ from 'lodash'
import React from 'react'
import {NullAsDefault, renderIf} from 'views/Shared'
import {ImagePlaceholder} from "../../../conts/imageBase64";
import {renderIfElse} from "../../Shared";
import {PiCertificate} from "react-icons/pi";
import {ItemInformation} from 'components/common/ItemInformation'
import {Image} from "antd";
import {baseFieldTypes} from "../../../apis/base/baseFieldTypes";
import classNames from "classnames";
import {BsChevronRight, BsEyeFill} from "react-icons/bs";

// Gradient cho header thẻ chứng nhận (grid) - chọn ổn định theo id/tên để không nhảy màu khi
// phân trang. 6 tông khớp mockup: xanh dương / tím / lục / cam / navy / hồng.
const MEDAL_GRADIENTS = [
    'linear-gradient(135deg, #3b82f6 0%, #4f46e5 100%)',
    'linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)',
    'linear-gradient(135deg, #10b981 0%, #047857 100%)',
    'linear-gradient(135deg, #f97316 0%, #c2410c 100%)',
    'linear-gradient(135deg, #334155 0%, #0f172a 100%)',
    'linear-gradient(135deg, #f43f5e 0%, #be123c 100%)',
]
export const medalGradient = (key) => {
    const s = String(key ?? '')
    let h = 0
    for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) | 0
    return MEDAL_GRADIENTS[Math.abs(h) % MEDAL_GRADIENTS.length]
}

const medalTags = (item) => Array.from(item?.tags ?? [])
    .map((e) => (typeof e === 'string' ? e : e?.tags))
    .filter(Boolean)

// ─── Thumbnail ảnh chứng nhận (khác avatar chữ ở Học viên/Môn học: đây là ảnh cert thật) ──────
const MedalThumb = ({item, size = 44}) => (
    renderIfElse(
        item?.avatar,
        <Image
            preview={false}
            src={item?.avatar}
            fallback={ImagePlaceholder}
            style={{width: size, height: size, flexShrink: 0}}
            className="rounded-lg object-cover bg-no-repeat"
            wrapperStyle={{width: size, height: size, flexShrink: 0}}
            wrapperClassName="rounded-lg"
        />,
        <div style={{width: size, height: size, flexShrink: 0}} className="flex flex-center background-200 rounded-lg">
            <PiCertificate size={size * 0.5} style={{color: '#dddddd'}}/>
        </div>
    )
)

// Pill dùng chung cho cả list + grid + modal chi tiết: viền, không nền.
export const LevelPill = ({level, t}) => renderIf(
    level !== undefined && level !== null && level !== '',
    <span className="w-fit flex items-center px-2 py-0.5 border border-blue-200 rounded-full text-2xs font-medium text-blue-500 whitespace-no-wrap">
        {`${t('level')}: ${level}`}
    </span>
)

export const MedalStatusBadge = ({active, t}) => {
    const isActive = active !== 0
    return (
        <span className={classNames(
            "w-fit flex items-center gap-1 px-2 py-0.5 border rounded-full text-2xs font-medium whitespace-no-wrap",
            isActive ? "border-green-200 text-green-600" : "border-amber-300 text-amber-500"
        )}>
            <span className={classNames("w-1.5 h-1.5 rounded-full flex-shrink-0", isActive ? "bg-green-500" : "bg-amber-400")}/>
            {t(_.find(baseFieldTypes.active, {value: active})?.label)}
        </span>
    )
}

// Tags: chữ hồng #tag (khớp thiết kế grid).
export const MedalTagChips = ({item}) => {
    const tags = medalTags(item)
    if (!tags.length) return null
    return (
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            {tags.map((tag) => (
                <span key={tag} className="text-2xs font-semibold text-rose-500 whitespace-no-wrap">
                    {`#${tag}`}
                </span>
            ))}
        </div>
    )
}

const renderMedal = ({translate: t, isLg, renderContextMenu } = {}) => (item, index) => {

    const tags = Array.from(item?.tags ?? [])

    return (
        <div key={index} className="p-4 flex flex-col md:flex-row gap-2 md:gap-3 custom-item-render relative list-item">
            {renderIfElse(
                item?.avatar,
                <Image
                    preview={false}
                    src={item?.avatar}
                    fallback={ImagePlaceholder}
                    style={{ width: isLg ? 120 : '100%', height: 120}}
                    className="rounded-xl object-cover bg-no-repeat"
                    wrapperStyle={{ width: isLg ? 120 : '100%' }}
                    wrapperClassName="rounded-xl"
                />,
                <div style={{ width: isLg ? 120 : '100%', height: 120 }} className="flex flex-center background-200 rounded-xl">
                    <PiCertificate size={60} style={{color: '#dddddd'}}/>
                </div>
            )}
            <div className="flex flex-col flex-1 relative">
                <h2 className="font-bold text-lg text-color-000 tracking-wide max-lines-1">
                    {getTitle(item)}
                </h2>
                <div className="flex flex-col md:flex-row md:items-center gap-x-6 gap-y-1">
                    <ItemInformation showIcon={false} label="level" value={item?.lvl_number} className="tracking-wider"/>
                    <ItemInformation showIcon={false} label="total_count" value={item?.total_count} className="tracking-wider"/>
                </div>
                <div className="my-2 border-b border-color-50"/>
                {renderIf(
                    tags.length,
                    <ItemInformation showIcon={true} label="tags" value={tags.map(({ tags }) => `#${tags}`).join(', ')} className="italic tracking-wider"/>
                )}
                <ItemInformation
                    showIcon={true} label="status"
                    value={
                        <span
                            className={classNames(
                                "px-2 py-0.5 border rounded-full text-2xs italic tracking-wider",
                                item.active === 0 ? 'border-amber-400 bg-amber-50 text-amber-400' : 'border-green-400 bg-green-50 text-green-500'
                            )}>
                            {t(_.find(baseFieldTypes.active, {value: item.active})?.label)}
                        </span>
                    }
                    className="text-xs italic tracking-wider"
                />

                {item?.description && (
                    <div className="mt-2 text-color-300 tracking-wider max-lines-3">
                        {item?.description}
                    </div>
                )}
            </div>
            {renderIf(
                _.isFunction(renderContextMenu) && isLg,
                <div className="absolute top-8 right-8 contextIcon">
                    {renderContextMenu(item)}
                </div>
            )}
        </div>
    )
}

// ─── Layout "Bảng" (mặc định) + "Thẻ" cho trang Chứng nhận khóa học (CourseMedals.js) ─────────
// KHÔNG đổi renderMedal gốc phía trên (WorkspaceMedalsList.js vẫn dùng). `onView` mở modal chi
// tiết cục bộ ở CourseMedals.js. Cột: CHỨNG NHẬN | CẤP ĐỘ | TRẠNG THÁI | LƯỢT CẤP | THAO TÁC
// (tag hồng nằm dưới title, không có cột riêng).
export const renderMedalTableRow = ({
    translate: t,
    renderContextMenu = NullAsDefault,
    onView = NullAsDefault,
} = {}) => (item, index) => {
    return (
        <tr key={index} className="border-t border-color-50 background hover:background-50 transition-colors align-top">
            <td className="px-3 py-2.5">
                <div className="flex items-center gap-2.5 min-w-0" style={{maxWidth: 320}}>
                    <MedalThumb item={item}/>
                    <div className="flex flex-col gap-1 min-w-0">
                        <span
                            onClick={() => onView(item)}
                            className="font-bold text-sm text-color-000 hover:text-primary cursor-pointer leading-snug max-lines-2">
                            {getTitle(item)}
                        </span>
                        <MedalTagChips item={item}/>
                    </div>
                </div>
            </td>
            <td className="px-3 py-2.5">
                {(item?.lvl_number !== undefined && item?.lvl_number !== null && item?.lvl_number !== '')
                    ? <LevelPill level={item?.lvl_number} t={t}/>
                    : <span className="text-xs text-color-300">—</span>}
            </td>
            <td className="px-3 py-2.5">
                <MedalStatusBadge active={item?.active} t={t}/>
            </td>
            <td className="px-3 py-2.5">
                <span className="font-medium text-xs text-gray-700 whitespace-no-wrap">
                    {item?.total_count > 0 ? `${item?.total_count} ${t('issuances')}` : '—'}
                </span>
            </td>
            <td className="px-3 py-2.5">
                <div className="flex items-center justify-end gap-2">
                    <button
                        type="button"
                        onClick={() => onView(item)}
                        style={{width: 28, height: 28}}
                        className="flex flex-center rounded-full border border-color-200 hover:border-primary hover:background-100 text-color-400 hover:text-primary">
                        <BsEyeFill size={13}/>
                    </button>

                    <div style={{width: 28, height: 28}} className="flex flex-center hover:background-200 rounded-lg cursor-pointer">
                        {renderContextMenu(item)}
                    </div>
                </div>
            </td>
        </tr>
    )
}

export const renderMedalCardItem = ({
    translate: t,
    renderContextMenu = NullAsDefault,
    onView = NullAsDefault,
} = {}) => (item, index) => {
    const {avatar, lvl_number, active, total_count, description} = item ?? {}
    const gradient = medalGradient(getId(item) || getTitle(item))

    return (
        <div
            key={index}
            className="p-4 flex flex-col gap-3 rounded-2xl border border-color-100 background overflow-hidden hover:shadow-lg transition-all duration-300 custom-item-render">
            {/* Header: ảnh chứng nhận (fallback placeholder gradient + icon nếu chưa có ảnh) */}
            <div className="relative" style={{height: 150}} onClick={() => onView(item)}>
                {renderIfElse(
                    avatar,
                    <Image
                        preview={false}
                        src={avatar}
                        fallback={ImagePlaceholder}
                        style={{width: '100%', height: 150, objectFit: 'cover'}}
                        wrapperStyle={{width: '100%', height: 150, display: 'block'}}
                        className="rounded-xl"
                        wrapperClassName="block rounded-xl"
                    />,
                    <div
                        style={{background: gradient, height: 150}}
                        className="flex flex-center cursor-pointer">
                        <PiCertificate size={52} style={{color: 'rgba(255,255,255,0.85)'}}/>
                    </div>
                )}
            </div>

            {/* Body */}
            <div className="flex flex-col gap-2.5 flex-1">
                <span
                    onClick={() => onView(item)}
                    className="font-bold text-base text-color-000 hover:text-primary cursor-pointer leading-snug max-lines-2">
                    {getTitle(item)}
                </span>

                <div className="flex flex-wrap items-center gap-1.5">
                    <LevelPill level={lvl_number} t={t}/>
                    <MedalStatusBadge active={active} t={t}/>
                </div>

                <MedalTagChips item={item}/>

                {renderIf(
                    description,
                    <div className="text-xs text-color-300 tracking-wider max-lines-2 whitespace-pre-line">
                        {description}
                    </div>
                )}

                <div className="mt-auto pt-2.5 border-t border-color-50 flex items-center justify-between gap-2">
                    {total_count > 0 ? (
                        <span className="text-xs text-color-300 whitespace-no-wrap">
                            {`${t('total_count')}: `}
                            <span className="font-bold text-color-100">{total_count}</span>
                        </span>
                    ) : (
                        <span />
                    )}

                    <div className="flex items-center gap-1.5 flex-shrink-0">
                        <div className="contextIcon px-2 py-1.5 hover:background-200 rounded-lg cursor-pointer">
                            {renderContextMenu(item)}
                        </div>
                        <button
                            type="button"
                            onClick={() => onView(item)}
                            className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-rose-50 hover:bg-rose-100 text-rose-500 font-semibold text-xs whitespace-no-wrap">
                            {t('view detail')}
                            <BsChevronRight size={11}/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default renderMedal
